const commonRenderItemRow = (columns, column, idx, item, index) =>
  columns.length - 1 === idx
    ? column?.renderSettings(item, index)
    : item[column?.name];

export default commonRenderItemRow;
